/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AdjacentGalleriesDto } from '../models/adjacent-galleries-dto';
import { CursorPaginationDto } from '../models/cursor-pagination-dto';
import { galleryControllerCreateV1 } from '../fn/gallery/gallery-controller-create-v-1';
import { GalleryControllerCreateV1$Params } from '../fn/gallery/gallery-controller-create-v-1';
import { galleryControllerDeleteV1 } from '../fn/gallery/gallery-controller-delete-v-1';
import { GalleryControllerDeleteV1$Params } from '../fn/gallery/gallery-controller-delete-v-1';
import { galleryControllerFindAdjacentV1 } from '../fn/gallery/gallery-controller-find-adjacent-v-1';
import { GalleryControllerFindAdjacentV1$Params } from '../fn/gallery/gallery-controller-find-adjacent-v-1';
import { galleryControllerFindAllV1 } from '../fn/gallery/gallery-controller-find-all-v-1';
import { GalleryControllerFindAllV1$Params } from '../fn/gallery/gallery-controller-find-all-v-1';
import { galleryControllerFindByIdV1 } from '../fn/gallery/gallery-controller-find-by-id-v-1';
import { GalleryControllerFindByIdV1$Params } from '../fn/gallery/gallery-controller-find-by-id-v-1';
import { galleryControllerSearchCursorV1 } from '../fn/gallery/gallery-controller-search-cursor-v-1';
import { GalleryControllerSearchCursorV1$Params } from '../fn/gallery/gallery-controller-search-cursor-v-1';
import { galleryControllerSearchV1 } from '../fn/gallery/gallery-controller-search-v-1';
import { GalleryControllerSearchV1$Params } from '../fn/gallery/gallery-controller-search-v-1';
import { galleryControllerToggleExposedV1 } from '../fn/gallery/gallery-controller-toggle-exposed-v-1';
import { GalleryControllerToggleExposedV1$Params } from '../fn/gallery/gallery-controller-toggle-exposed-v-1';
import { galleryControllerTogglePinnedV1 } from '../fn/gallery/gallery-controller-toggle-pinned-v-1';
import { GalleryControllerTogglePinnedV1$Params } from '../fn/gallery/gallery-controller-toggle-pinned-v-1';
import { galleryControllerUpdateV1 } from '../fn/gallery/gallery-controller-update-v-1';
import { GalleryControllerUpdateV1$Params } from '../fn/gallery/gallery-controller-update-v-1';
import { GalleryDto } from '../models/gallery-dto';
import { OffsetPaginationDto } from '../models/offset-pagination-dto';

@Injectable({ providedIn: 'root' })
export class GalleryService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `galleryControllerSearchV1()` */
  static readonly GalleryControllerSearchV1Path = '/api/v1/gallery/search';

  /**
   * Gallery 검색.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `galleryControllerSearchV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  galleryControllerSearchV1$Response(params?: GalleryControllerSearchV1$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto & {
'items'?: Array<GalleryDto>;
}>> {
    return galleryControllerSearchV1(this.http, this.rootUrl, params, context);
  }

  /**
   * Gallery 검색.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `galleryControllerSearchV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  galleryControllerSearchV1(params?: GalleryControllerSearchV1$Params, context?: HttpContext): Observable<OffsetPaginationDto & {
'items'?: Array<GalleryDto>;
}> {
    return this.galleryControllerSearchV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto & {
'items'?: Array<GalleryDto>;
}>): OffsetPaginationDto & {
'items'?: Array<GalleryDto>;
} => r.body)
    );
  }

  /** Path part for operation `galleryControllerSearchCursorV1()` */
  static readonly GalleryControllerSearchCursorV1Path = '/api/v1/gallery/search/cursor';

  /**
   * Gallery 커서 기반 검색.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `galleryControllerSearchCursorV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  galleryControllerSearchCursorV1$Response(params?: GalleryControllerSearchCursorV1$Params, context?: HttpContext): Observable<StrictHttpResponse<CursorPaginationDto & {
'items'?: Array<GalleryDto>;
}>> {
    return galleryControllerSearchCursorV1(this.http, this.rootUrl, params, context);
  }

  /**
   * Gallery 커서 기반 검색.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `galleryControllerSearchCursorV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  galleryControllerSearchCursorV1(params?: GalleryControllerSearchCursorV1$Params, context?: HttpContext): Observable<CursorPaginationDto & {
'items'?: Array<GalleryDto>;
}> {
    return this.galleryControllerSearchCursorV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<CursorPaginationDto & {
'items'?: Array<GalleryDto>;
}>): CursorPaginationDto & {
'items'?: Array<GalleryDto>;
} => r.body)
    );
  }

  /** Path part for operation `galleryControllerFindAllV1()` */
  static readonly GalleryControllerFindAllV1Path = '/api/v1/gallery';

  /**
   * 모든 Gallery 목록 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `galleryControllerFindAllV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  galleryControllerFindAllV1$Response(params?: GalleryControllerFindAllV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<GalleryDto>>> {
    return galleryControllerFindAllV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 모든 Gallery 목록 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `galleryControllerFindAllV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  galleryControllerFindAllV1(params?: GalleryControllerFindAllV1$Params, context?: HttpContext): Observable<Array<GalleryDto>> {
    return this.galleryControllerFindAllV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<GalleryDto>>): Array<GalleryDto> => r.body)
    );
  }

  /** Path part for operation `galleryControllerCreateV1()` */
  static readonly GalleryControllerCreateV1Path = '/api/v1/gallery';

  /**
   * Gallery 생성.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `galleryControllerCreateV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  galleryControllerCreateV1$Response(params: GalleryControllerCreateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<GalleryDto>> {
    return galleryControllerCreateV1(this.http, this.rootUrl, params, context);
  }

  /**
   * Gallery 생성.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `galleryControllerCreateV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  galleryControllerCreateV1(params: GalleryControllerCreateV1$Params, context?: HttpContext): Observable<GalleryDto> {
    return this.galleryControllerCreateV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<GalleryDto>): GalleryDto => r.body)
    );
  }

  /** Path part for operation `galleryControllerFindAdjacentV1()` */
  static readonly GalleryControllerFindAdjacentV1Path = '/api/v1/gallery/{id}/adjacent';

  /**
   * 이전글/다음글 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `galleryControllerFindAdjacentV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  galleryControllerFindAdjacentV1$Response(params: GalleryControllerFindAdjacentV1$Params, context?: HttpContext): Observable<StrictHttpResponse<AdjacentGalleriesDto>> {
    return galleryControllerFindAdjacentV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 이전글/다음글 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `galleryControllerFindAdjacentV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  galleryControllerFindAdjacentV1(params: GalleryControllerFindAdjacentV1$Params, context?: HttpContext): Observable<AdjacentGalleriesDto> {
    return this.galleryControllerFindAdjacentV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<AdjacentGalleriesDto>): AdjacentGalleriesDto => r.body)
    );
  }

  /** Path part for operation `galleryControllerFindByIdV1()` */
  static readonly GalleryControllerFindByIdV1Path = '/api/v1/gallery/{id}';

  /**
   * Gallery id로 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `galleryControllerFindByIdV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  galleryControllerFindByIdV1$Response(params: GalleryControllerFindByIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<GalleryDto>> {
    return galleryControllerFindByIdV1(this.http, this.rootUrl, params, context);
  }

  /**
   * Gallery id로 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `galleryControllerFindByIdV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  galleryControllerFindByIdV1(params: GalleryControllerFindByIdV1$Params, context?: HttpContext): Observable<GalleryDto> {
    return this.galleryControllerFindByIdV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<GalleryDto>): GalleryDto => r.body)
    );
  }

  /** Path part for operation `galleryControllerDeleteV1()` */
  static readonly GalleryControllerDeleteV1Path = '/api/v1/gallery/{id}';

  /**
   * Gallery 삭제.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `galleryControllerDeleteV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  galleryControllerDeleteV1$Response(params: GalleryControllerDeleteV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return galleryControllerDeleteV1(this.http, this.rootUrl, params, context);
  }

  /**
   * Gallery 삭제.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `galleryControllerDeleteV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  galleryControllerDeleteV1(params: GalleryControllerDeleteV1$Params, context?: HttpContext): Observable<boolean> {
    return this.galleryControllerDeleteV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `galleryControllerUpdateV1()` */
  static readonly GalleryControllerUpdateV1Path = '/api/v1/gallery/{id}';

  /**
   * Gallery 수정.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `galleryControllerUpdateV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  galleryControllerUpdateV1$Response(params: GalleryControllerUpdateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<GalleryDto>> {
    return galleryControllerUpdateV1(this.http, this.rootUrl, params, context);
  }

  /**
   * Gallery 수정.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `galleryControllerUpdateV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  galleryControllerUpdateV1(params: GalleryControllerUpdateV1$Params, context?: HttpContext): Observable<GalleryDto> {
    return this.galleryControllerUpdateV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<GalleryDto>): GalleryDto => r.body)
    );
  }

  /** Path part for operation `galleryControllerTogglePinnedV1()` */
  static readonly GalleryControllerTogglePinnedV1Path = '/api/v1/gallery/{id}/pin';

  /**
   * 갤러리 고정/고정해제.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `galleryControllerTogglePinnedV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  galleryControllerTogglePinnedV1$Response(params: GalleryControllerTogglePinnedV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return galleryControllerTogglePinnedV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 갤러리 고정/고정해제.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `galleryControllerTogglePinnedV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  galleryControllerTogglePinnedV1(params: GalleryControllerTogglePinnedV1$Params, context?: HttpContext): Observable<boolean> {
    return this.galleryControllerTogglePinnedV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `galleryControllerToggleExposedV1()` */
  static readonly GalleryControllerToggleExposedV1Path = '/api/v1/gallery/{id}/expose';

  /**
   * 갤러리 노출/노출해제.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `galleryControllerToggleExposedV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  galleryControllerToggleExposedV1$Response(params: GalleryControllerToggleExposedV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return galleryControllerToggleExposedV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 갤러리 노출/노출해제.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `galleryControllerToggleExposedV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  galleryControllerToggleExposedV1(params: GalleryControllerToggleExposedV1$Params, context?: HttpContext): Observable<boolean> {
    return this.galleryControllerToggleExposedV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

}
